
class AuthComponent {

    constructor(){

        this.state = {
            role: '',
            permissions: []
        }
        

        //Singleton instance of AuthComponent
        if(this.constructor.instance)
            return this.constructor.instance;
        this.constructor.instance = this;


         
    }

    // authenticate(){
    //     window.location = "/auth/login";
    // }

    authenticateKeycloak(){
        window.location = "/auth/loginKeycloak";
    }

    // logout(){
    //     window.location = "/auth/logout";
    // }

    logoutKeycloak(){
        window.location = "/auth/logoutKeycloak";
    }

    // isAuthenticated(returnFunction){
    //     const http = new XMLHttpRequest()
    //     // var host = process.env.PUBLIC_URL;
    //     // http.open("GET", host.concat("/auth/isAuthenticated"))
    //     http.open("GET", "/auth/isAuthenticated");
    //     http.send()

    //     http.onload = () => {
    //         var response = http.response
    //         returnFunction(response);
    //     }
    // }

    // getAttributes(returnFunction){
    //     const http = new XMLHttpRequest()
    //     http.open("GET", "/auth/getAttributes")
    //     http.send()
    
    //     http.onload = () => {
    //         var response = http.response
    //         returnFunction(response);
    //     }
    //   }

      isAuthenticatedKeycloak(returnFunction){
        const http = new XMLHttpRequest()
        // var host = process.env.PUBLIC_URL;
        // http.open("GET", host.concat("/auth/isAuthenticated"))
        http.open("GET", "/auth/isAuthenticatedKeycloak");
        http.send()

        http.onload = () => {
            var response = http.response
            returnFunction(response);
        }
    }

    getAttributesKeycloak(returnFunction){
        const http = new XMLHttpRequest()
        http.open("GET", "/auth/getAttributesKeycloak")
        http.send()
    
        http.onload = () => {
            var response = http.response
            returnFunction(response);
        }
      }


    //   getPermissions(returnFunction){

    //     if (this.state.permissions.length != 0){
    //         returnFunction(this.state.role,this.state.permissions);
    //     } else {
 
    //         const http = new XMLHttpRequest()
    //         http.open("GET", "/auth/getAttributes")
    //         http.send()
        
    //         http.onload = () => {
    //             var response = http.response
    //             var resp = JSON.parse(response);

    //             // User not authenticated
    //             if (resp["value"] == false){
    //                 returnFunction("User not authenticated");
    //             } else {
    //                 var attributes = resp["attributes"]
    //                 var memberOf = attributes["memberof"];
    //                 var external_match = 'ocf-central-default';
    //                 if (typeof(memberOf) != "undefined"){
    //                     for (let index = 0; index < memberOf.length; index++) {
    //                         var element = memberOf[index];
    //                         if (element.includes('ocf-central')){
    //                             external_match = element;
    //                             break;
    //                         }   
    //                     }
    //                 }
                    
    //                 // Get permissions
    //                 const http2 = new XMLHttpRequest()
    //                 http2.open("GET", "/api/role/getByExternalMatch/" + external_match)
    //                 http2.send()
                
    //                 http2.onload = () => {
    //                     var response = http2.response
    //                     var resp = JSON.parse(response);
    //                     var role = '';
    //                     var permissions = [];
    //                     if (resp["result"] == "Role found"){
    //                         permissions = resp["message"]["permissions"]
    //                         // permissions = [resp["message"]["instances"],resp["message"]["healthcheck"],resp["message"]["telemetry"],resp["message"]["license"],resp["message"]["logging"],resp["message"]["notifications"],resp["message"]["business"],resp["message"]["emmaabs"],resp["message"]["identities"]]
    //                         role = resp["message"]["name"];
    //                         this.state.role = role
    //                         this.state.permissions = permissions
    //                         // this.setState({role: resp["message"]["name"], permissions: permissions})
    //                     } else if (resp["result"] == "Role not found, returning 'default' role permissions") {
    //                         permissions = resp["message"]["permissions"]
    //                         // permissions = [resp["message"]["instances"],resp["message"]["healthcheck"],resp["message"]["telemetry"],resp["message"]["license"],resp["message"]["logging"],resp["message"]["notifications"],resp["message"]["business"],resp["message"]["emmaabs"],resp["message"]["identities"]]
    //                         role = resp["message"]["name"];
    //                         this.state.role = role
    //                         this.state.permissions = permissions
    //                         // this.setState({role: resp["message"]["name"], permissions: permissions})
    //                     }
    //                     returnFunction(role,permissions);
    //                 }
    //             }
                
    //         }
    //     }
    //   }


      getPermissionsKeycloak(returnFunction){

        if (this.state.permissions.length != 0){
            returnFunction(this.state.role,this.state.permissions);
        } else {
 
            const http = new XMLHttpRequest()
            http.open("GET", "/auth/getAttributesKeycloak")
            http.send()
        
            http.onload = () => {
                var response = http.response
                var resp = JSON.parse(response);

                // User not authenticated
                if (resp["value"] == false){
                    returnFunction("User not authenticated");
                } else {
                    var attributes = resp["attributes"]
                    var memberOf = attributes["memberof"];
                    var external_match = 'ocf-central-default';
                    if (typeof(memberOf) != "undefined"){
                        for (let index = 0; index < memberOf.length; index++) {
                            var element = memberOf[index];
                            if (element.includes('ocf-central')){
                                external_match = element;
                                break;
                            }   
                        }
                    }
                    
                    // Get permissions
                    const http2 = new XMLHttpRequest()
                    http2.open("GET", "/api/role/getByExternalMatch/" + external_match)
                    http2.send()
                
                    http2.onload = () => {
                        var response = http2.response
                        var resp = JSON.parse(response);
                        var role = '';
                        var permissions = [];
                        if (resp["result"] == "Role found"){
                            permissions = resp["message"]["permissions"]
                            // permissions = [resp["message"]["instances"],resp["message"]["healthcheck"],resp["message"]["telemetry"],resp["message"]["license"],resp["message"]["logging"],resp["message"]["notifications"],resp["message"]["business"],resp["message"]["emmaabs"],resp["message"]["identities"]]
                            role = resp["message"]["name"];
                            this.state.role = role
                            this.state.permissions = permissions
                            // this.setState({role: resp["message"]["name"], permissions: permissions})
                        } else if (resp["result"] == "Role not found, returning 'default' role permissions") {
                            permissions = resp["message"]["permissions"]
                            // permissions = [resp["message"]["instances"],resp["message"]["healthcheck"],resp["message"]["telemetry"],resp["message"]["license"],resp["message"]["logging"],resp["message"]["notifications"],resp["message"]["business"],resp["message"]["emmaabs"],resp["message"]["identities"]]
                            role = resp["message"]["name"];
                            this.state.role = role
                            this.state.permissions = permissions
                            // this.setState({role: resp["message"]["name"], permissions: permissions})
                        }
                        returnFunction(role,permissions);
                    }
                }
                
            }
        }
      }


}

export default AuthComponent;
